import type { Router } from 'vue-router'
import { useMenuPermissions } from '@/composables/useMenuPermissions'
import { PERMISSIONS, ROLES } from '@/constants/permissions'
//USER_TYPES = INTERNAL, EXTERNAL
// Définition des routes protégées avec leurs permissions
const protectedRoutes: Record<string, { roles?: string[], permissions?: string[], userTypes?: string[] }> = {
  '/dashboards': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.DASHBOARD.READ]
  },
  '/dashboards/editor': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.DASHBOARD.CREATE]
  },
  '/employes': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.EMPLOYEE.READ]
  },
  '/paie': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.PAYROLL.READ]
  },
  '/absences': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.ABSENCE.READ]
  },
  '/presence': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.ATTENDANCE.READ]
  },
  '/remuneration': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    permissions: [PERMISSIONS.REMUNERATION.MANAGE_SALARIES]
  },
  '/notes-frais': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.EXPENSE.READ]
  },
  '/syndicats': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.UNION.READ]
  },
  '/equipements': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.EQUIPMENT.READ]
  },
  '/documents': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.DOCUMENT.READ]
  },
  '/document-templates': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    permissions: [PERMISSIONS.DOCUMENT_TEMPLATE.READ]
  },
  '/reports': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN, ROLES.MANAGER],
    permissions: [PERMISSIONS.REPORTS.READ]
  },
  '/configuration': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    permissions: [PERMISSIONS.SETTINGS.READ]
  },
  '/utilisateurs': {
    roles: [ROLES.SUPER_ADMIN, ROLES.ADMIN],
    permissions: [PERMISSIONS.USER.READ]
  }
}

export function setupRouteGuards(router: Router) {
  router.beforeEach((to, _from, next) => {
    // Routes publiques qui ne nécessitent pas de vérification de permissions
    const publicRoutes = ['/login', '/forgot-password', '/reset-password', '/access-denied']
    const isPublicRoute = publicRoutes.some(route => to.path.startsWith(route))
    
    // Si c'est une route publique, autoriser l'accès
    if (isPublicRoute) {
      next()
      return
    }
    
    const { canAccessRoute } = useMenuPermissions()
    
    // Vérifier si la route est protégée
    const routeConfig = protectedRoutes[to.path]
    
    if (routeConfig) {
      // Vérifier les permissions
      if (!canAccessRoute(to.path)) {
        // Rediriger vers la page d'accès refusé
        next('/access-denied')
        return
      }
    }
    
    next()
  })
}
